// ломает скрипты на несвежих айфонах
// import './libs/flex-gap-polyfill';
import './blocks/search-main';
import ProductCarousel from './blocks/slider-product'
import NewRecipesCarousel from './blocks/slider-new-recipes'
import sliderArticle from './blocks/slider-article'

//components
import './blocks/popup'
import './blocks/menu'
import './blocks/dropdown'
import './blocks/form'
import './blocks/tab-form'
import './blocks/anchorScroll'
import './blocks/pagination'

addEventListener('ajax:update-complete', () => {
    ProductCarousel.init();
    NewRecipesCarousel.init();
    sliderArticle.init();
})

